//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Advancelist.js";
import { tolocalestringnumber } from "../computing/tolocalestringnumber";
import unity from "@/unity/unity";
const moment = require('moment');

export default {
    name: "advance-list",
    data(vm) {
        return {
            dialogAdd: false,
            text_color: "text-h5 green--text text-center",
            title: "green",
            message: "green",
            link: "",
            search_status: "",
            menu: false,
            menu2: false,
            search: "",
            toggleEnable: false,
            selectstatus: "",
            dataAll: [],
            status: ["Draft", "Request", "Approve", "Reject"],
            datefrom: null,
            dateto: null,
            dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
            seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
            setlanguage: language.en,
            defaultlanguage: "en",
            // regexlang: "th",
            chooselanguage: [
            { name: "en", flag: "gb" },
            { name: "th", flag: "th" },
            ],
            aa: "สวัสดี",
            dialogEdit: false,
            dialogDelete: false,
            mDataArray: [],
            position: [],
            approver: [],
            department: [],
            department_list: [],
            position_list: [],
            company: [],
            authorize: [],
            headers: [
                {
                    text: "Date",
                    value: "dateshow",
                    class: "bg-colorth tabletextwhite",
                    divider: true,
                    width: "100px"
                },
                {
                    text: "Status",
                    value: "statusshow",
                    class: "bg-colorth tabletextwhite",
                    divider: true,
                    width: "100px"
                },
                {
                    text: "In/Out Time",
                    value: "timeshow",
                    class: "bg-colorth tabletextwhite",
                    divider: true,
                    width: "100px",
                },
                {
                    text: "Location on Check In",
                    value: "location",
                    class: "bg-colorth tabletextwhite",
                    divider: true,
                    width: "150px" ,
                },
            ],
            charge_list: [
            { value: "T/C", name: "Time Charge" },
            { value: "N/C", name: "No Charge" },
            { value: "F/C", name: "Fix Charge" },
            { value: "OFF", name: "ทำงานออฟฟิต" },
        ],
            jobTitle_list: [],
            searchCharge: null,
            searchChargeJob: null,
            searchEmp: [],
            delete_id: 0,
            dialogDeleteActivity: false,
        };
    },

    async beforeCreate() {
        console.log("beforeCreate");
        this.$store.state.navMenu = true;
    },
    async created() {
        // this.initialize();
    },
    components: {
        SuccessDialog,
    },
    beforeUpdate() {},
    computed: {
        computeddatefromFormatted() {
            return unity.formatDate(this.datefrom);
        },
        computeddateToFormatted() {
            return unity.formatDate(this.dateto);
        },
        itemsForSelected() {
            if (this.search.length) {
            return this.dataSource.filter((item) => this.search.includes(item));
            }
            return this.dataSource;
        },
    },
    async mounted() {
        await api.checkVersion();
        this.userId = localStorage.getItem(server.USER_ID);
        let yourUrlString = window.location;
        // alert(yourUrlString);

        let parser = document.createElement("a");
        parser.href = yourUrlString;

        this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

        // alert("authorize_id:" + this.authorize_id);
        if (this.authorize_id == null || this.authorize_id == 0) {
            // this.$router.push("/login");
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
            true,
            "Authorize Failed",
            "Please Logout And Login Again",
            "text-h5 red--text text-center"
            );
            this.$router.back();
        }

        const router_path = parser.pathname.replace("/", "");

        const res_auth = await api.getAuthorize(this.userId, router_path);

        // // console.log("res_auth:" + JSON.stringify(res_auth.data));

        this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
        this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
        this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
        this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

        console.log("res_auth:" + JSON.stringify(res_auth.data));
        console.log("authorize_view:" + this.authorize_view);
        console.log("authorize_add:" + this.authorize_add);
        console.log("authorize_edit:" + this.authorize_edit);
        console.log("authorize_del:" + this.authorize_del);
        // this.$router.back();

        if (!this.authorize_view) {
            this.$router.push("/not-found");
        }

        // ----------------- Check Authorize ---------------------------

        let comp_id = localStorage.getItem(server.COMPANYID);
        // await this.loadCompanyMaster(comp_id);
        // await this.loadDepartmentMaster(comp_id);
        // await this.loadPositionMaster(comp_id);

        await this.loadAuthorize();
        await this.setStartAndEndOfMonth();

        this.userId = localStorage.getItem(server.USER_ID);
        if (this.userId && api.isLoggedIn()) {
            // this.$router.push("/");
        } else {
            this.$store.state.isLogged = false;
            this.$router.push("/login");
        }
    },
    methods: {
        setupAlertDialog(status, title, message, text_color) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
        },
        async setStartAndEndOfMonth() {
            const today = new Date();
            
            // วันที่ 1 ของเดือนนี้
            const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            this.datefrom = moment(startOfMonth).format("YYYY-MM-DD");;

            // วันที่สุดท้ายของเดือนนี้
            const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            this.dateto = moment(endOfMonth).format("YYYY-MM-DD");

            await this.loaddata();
        },
        async loadAuthorize() {
            const res_get = await api.getSettingGroupMenu();
            // console.log("res loadAuthorize : ", JSON.stringify(res_get));
            this.authorize = res_get.data;
        },

        async loaddata() {
            const resData = await api.getAllCheckInOutByUserID(localStorage.getItem(server.USER_ID),this.datefrom,this.dateto)   
            this.dataAll = resData.data;
            this.mDataArray = resData.data;
            this.$hideLoader();
        },
        async searchdata(){
            this.$showLoader(); 
            const resData = await api.getAllCheckInOutByUserID(localStorage.getItem(server.USER_ID),this.datefrom,this.dateto) 
            this.dataAll = resData.data;
            this.mDataArray = resData.data;
            this.$hideLoader(); 
        },
        openPreviewMaps(data) {
            // ใช้ Regular Expression เพื่อดึงพิกัดจากข้อมูล
            const regex = /([\d.-]+)\s*,\s*([\d.-]+)/;
            const matches = data.match(regex);
            
            if (matches) {
                const lat = matches[1];  // ละติจูด (latitude)
                const lng = matches[2];  // ลองจิจูด (longitude)

                // สร้าง URL สำหรับเปิด Google Maps ที่จุดเดียว
                const url = `https://www.google.com/maps?q=${encodeURIComponent(lat)},${encodeURIComponent(lng)}`;
                window.open(url, '_blank');
            } else {
                console.error('ไม่พบพิกัดในข้อมูล');
            }
        }
    },
};
